/**
 * Public (no-auth) axios instance for NKognito Live Player + Screen surfaces.
 * The Host uses hostApi.js (with host_session_token).
 */
import axios from "axios";

export const liveApi = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: false,
});

/**
 * Persist a per-browser random tempid used to identify a player across
 * refreshes. This is intentionally in localStorage and not tied to any NK
 * account since Live is anonymous-friendly.
 */
export function getPlayerTempId() {
  const KEY = "nk_live_player_tempid";
  let id = localStorage.getItem(KEY);
  if (!id) {
    id = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2, 10)}`);
    localStorage.setItem(KEY, id);
  }
  return id;
}

export function buildLiveWsUrl({ code, role, playerTempId }) {
  const wsBase = (process.env.REACT_APP_BACKEND_URL || "").replace(/^http/, "ws");
  const params = new URLSearchParams({ role: role || "screen" });
  if (playerTempId) params.set("player_tempid", playerTempId);
  return `${wsBase}/api/live/events/${code}/ws?${params.toString()}`;
}
